import { PERIODS, SKUS, isBundled } from '@/modules/usage/constants/countables';

const row = (key, period, credit, usage) => ({
  key: `${SKUS.SMS}-${key}`,
  period,
  unlimited: false,
  consumed: usage,
  credit,
  left: credit - usage,
  resetsAt: null,
  expiresAt: null,
});

export const toUsageRows = (smsQuotas) => {
  if (!smsQuotas) return [];

  const monthlyCredit = smsQuotas.sms_monthly_credit || 0;
  const oneTimeCredit = smsQuotas.sms_credit || 0;
  const rows = [];

  if (monthlyCredit > 0) {
    rows.push(row('monthly', PERIODS.MONTHLY, monthlyCredit, smsQuotas.sms_monthly_usage || 0));
  }

  if (oneTimeCredit > 0) {
    rows.push(row('one-time', PERIODS.LIFE_LONG, oneTimeCredit, smsQuotas.sms_usage || 0));
  }

  return rows;
};

export const fromBalance = (balance) => {
  if (typeof balance !== 'number') return [];

  return [{
    key: `${SKUS.SMS}-balance`,
    period: PERIODS.BALANCE,
    unlimited: false,
    consumed: null,
    credit: null,
    left: balance,
    resetsAt: null,
    expiresAt: null,
  }];
};

const quantityOf = (subscriptions) => subscriptions
  .reduce((sum, subscription) => sum + (Number(subscription.quantity) || 0), 0);

const firstOfNextMonth = () => {
  const date = new Date();
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1)).toISOString();
};

export const fromSubscriptions = (balance, subscriptions = []) => {
  if (typeof balance !== 'number') return [];

  const monthly = subscriptions.filter(isBundled);
  const oneTime = subscriptions.filter((subscription) => !isBundled(subscription));
  if (monthly.length > 0 && oneTime.length > 0) return fromBalance(balance);

  const onlyMonthly = monthly.length > 0;
  const credit = quantityOf(onlyMonthly ? monthly : oneTime);
  if (credit <= 0 || balance > credit) return fromBalance(balance);

  return [{
    key: `${SKUS.SMS}-${onlyMonthly ? 'monthly' : 'one-time'}`,
    period: onlyMonthly ? PERIODS.MONTHLY : PERIODS.LIFE_LONG,
    unlimited: false,
    consumed: credit - balance,
    credit,
    left: balance,
    resetsAt: onlyMonthly ? firstOfNextMonth() : null,
    expiresAt: null,
  }];
};

export default { toUsageRows, fromBalance, fromSubscriptions };
